import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { repositoryFactory } from '@rammetec/data-access';
import { rtLogService, useDispatchHookEvent } from '@rammetec/core';
/**
 * Provides a centralized function to perform a full data sync across the application.
 * This encapsulates the logic for clearing custom repository caches and invalidating all react-query queries.
 */
export const useSync = () => {
    const queryClient = useQueryClient();
    const [isSyncing, setIsSyncing] = useState(false);
    const sync = async () => {
        setIsSyncing(true);
        try {
            rtLogService.info('Sync initiated');
            rtLogService.flush();
            // 1. Clear the custom cache layer in the repositories
            repositoryFactory.invalidateAllCaches();
            // 2. Invalidate all queries in the react-query cache, triggering a global refetch
            await queryClient.invalidateQueries();
        }
        finally {
            setIsSyncing(false);
        }
    };
    useDispatchHookEvent('useSync', {});
    return { sync, isSyncing };
};
//# sourceMappingURL=useSync.js.map